import React from "react";
import { Button, FormControl, Grid, TextField } from "@material-ui/core";
import { Edit } from "@material-ui/icons";
import { Formik } from "formik";
import { buildingSchema, useStyleFormAssignRoom } from "../helpers/AssignBuildEvtOption";

const FormBuilding = ({ onSubmit = () => {}, initialFormValues = {}, isCreateForm = true }) => {
    const classes = useStyleFormAssignRoom();
    return (
        <Formik initialValues={initialFormValues} validationSchema={buildingSchema} onSubmit={onSubmit}>
            {({ handleChange, handleSubmit, values, errors }) => (
                <Grid container spacing={4} className="px-5 justify-content-center">
                    <Grid item xs={12} sm={isCreateForm ? 6 : 12} lg={isCreateForm ? 4 : 12}>
                        <Grid container spacing={0} className="align-items-center">
                            <Grid item xs={5}>
                                <label className="mb-0">
                                    สร้างอาคาร <span className="text-danger">*</span>
                                </label>
                            </Grid>
                            <Grid item xs={7}>
                                <FormControl className="t-form-group-custom w-100">
                                    <TextField
                                        className={`h-100 ${classes.input}`}
                                        InputProps={{
                                            endAdornment: <Edit />,
                                        }}
                                        fullWidth
                                        size="small"
                                        type="text"
                                        name="buildingName"
                                        label="สร้างอาคาร"
                                        variant="outlined"
                                        value={values?.buildingName}
                                        onChange={handleChange}
                                        error={Boolean(errors?.buildingName)}
                                        helperText={errors?.buildingName}
                                        FormHelperTextProps={{
                                            className: "text-danger position-absolute",
                                            style: { bottom: -25, left: -12 },
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} sm={isCreateForm ? 3 : 12} lg={isCreateForm ? 1 : 12}>
                        <Grid className="align-items-center justify-content-center h-100">
                            <Grid item xs={12} className="h-100">
                                <Button onClick={handleSubmit} className="t-btn-primary w-100 h-100">
                                    {isCreateForm ? "Add" : "Edit"}
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </Formik>
    );
};

export default FormBuilding;
